import { States } from 'safe'
import {
  CLEAN_SELLS,
  ENABLE_SELLER,
  SellerTypes,
  SellsTypes,
  SET_SELLERS,
  SET_SELLS,
  UPDATE_SALE,
} from '../actions/actionTypes'

const initialState: States.Sellers = {
  sellers: [],
  numberOfPages: 0,
}

export default (state = initialState, action: SellerTypes): States.Sellers => {
  let _sellers, index
  switch (action.type) {
    case SET_SELLERS:
      return {
        ...action.payload,
      }
    case ENABLE_SELLER:
      _sellers = [...state.sellers]
      index = _sellers.findIndex((i) => i.id === action.payload.id)
      _sellers[index] = {
        ..._sellers[index],
        enable: action.payload.enable,
      }
      return { ...state, sellers: _sellers }
    default:
      return state
  }
}
